<template>
<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Star 1" d="M6.61749 0.750836C6.73289 0.373469 7.26711 0.373468 7.38251 0.750835L8.70956 5.09033C8.76099 5.2585 8.91622 5.37336 9.09208 5.37336L13.4357 5.37336C13.8173 5.37336 13.9822 5.85681 13.6801 6.08999L10.1252 8.83424C9.99339 8.93596 9.93839 9.10866 9.98707 9.26785L11.335 13.6755C11.449 14.0484 11.0167 14.3474 10.708 14.1091L7.24443 11.4354C7.10043 11.3242 6.89957 11.3242 6.75557 11.4354L3.29197 14.1091C2.98335 14.3474 2.55101 14.0484 2.66503 13.6755L4.01293 9.26785C4.06161 9.10866 4.00661 8.93596 3.87484 8.83424L0.319888 6.08999C0.0178238 5.85681 0.182716 5.37336 0.564312 5.37336L4.90793 5.37336C5.08378 5.37336 5.23901 5.2585 5.29044 5.09033L6.61749 0.750836Z" fill="#F9B918"/>
</svg>

</template>
<script>
const starRatingIcon = {
    name: 'starRatingIcon',
}
export default starRatingIcon
export { starRatingIcon }
</script>
